// styles.js – inclui layout unificado com aparência de um único card
import styled from 'styled-components';

export const ContainerUnico = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  background-color: #f9f9f9;
  border: 2px solid #cf0505;
  border-radius: 12px;
  padding: 30px;
  max-width: 1200px;
  margin: 100px auto 150px auto;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
    margin: 80px auto 100px auto;
  }
`;

export const Coluna = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 300px;
`;

export const Title = styled.h1`
  color: #cf0505;
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
`;

export const InputGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #333;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #cf0505;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-size: 16px;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: #cf0505;
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #003366;
  color: white;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #002244;
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 100px;
  left: 20px;
  background-color: transparent;
  border: none;
  font-size: 16px;
  color: #cf0505;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #800000;
  }
`;

export const PreviewTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;

  span {
    font-size: 14px;
  }
`;

export const RefreshButton = styled.button`
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  padding: 0;

  &:hover {
    color: #004499;
  }
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #ff0000;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  padding: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(255, 0, 0, 0.1);
    transform: scale(1.1);
  }
`;

export const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
  min-height: 200px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 300px;
  }
`;